import './App.scss';
import { OidcProvider } from 'redux-oidc';
import userManager from './settings/oAuthSettings';
import ChatPage from './components/ChatPage';
import { store } from './redux/store'
import { useEffect, useState } from 'react';
import { User } from 'oidc-client-ts';
import ChatList from './components/ChatList';
import { useReduxDispatch } from './redux/hooks';
import { StartConnecting } from './redux/reducers/ChatSlice';
import { Route, Router, Routes } from 'react-router-dom';
import { ChatApi } from './redux/api/ChatApi';
import ChatDialog from './components/ChatDialog';
import ChatRequest from './components/ChatRequest';
import Nav from './components/Header/Nav';
import PinnedChats from './components/PinnedChats';
import ChatNotification from './components/ChatNotification';

export default function App() {
  const dispatch = useReduxDispatch();
  const [user, setUser] = useState<User>();
  const { data: userProfile, error: fetchError } = ChatApi.useGetProfileQuery();

  useEffect(() => {
    checkUser();

    //console.log('Create StartConnecting');
    //var action = StartConnecting(null);
    //console.log('dispatching StartConnecting');
    //dispatch(action);
  }, [fetchError])

  const checkUser = async () => {
    let u = await userManager.getUser();

    console.log('fetchError', fetchError?.["status"])


    u && setUser(u as unknown as User)
    console.log('User Expired', u, u?.expired);

    if (!u || u?.expired || fetchError?.["status"] === 401) {
      console.log('signinRedirect')
      await userManager.signinRedirect();
    }
  };


  if (!user)
    return <>Loading...</>

  return (
    <OidcProvider store={store} userManager={userManager}>
      <div className="App">
        <Nav />
        <Routes>
          <Route path="/list" element={<ChatList />} />
          <Route path="/dude" element={<>Dude</>} />
          <Route path="/chat/request" element={<ChatRequest />} />
          <Route path="/chat/:id" element={<ChatPage />} />
          <Route path="/*" element={<ChatPage />} />
          <Route path="/chat/pinned" element={<>
            <ChatPage />
            <PinnedChats />
          </>} />

        </Routes>
        {/* <PinnedChats /> */}
      </div>
    </OidcProvider>

  );
}
